module.exports = __webpack_public_path__ + "static/media/4530.ee9d87dd.jpg";